import { Grid, TableCell, TableRow, Typography } from "@material-ui/core";
import React from "react";
import styled from "styled-components";

const Row = styled(TableRow)`
  display: flex;
  justify-content: space-around;
  align-items: center;
`;

const Cell = styled(TableCell)`
  border: none;
  padding-bottom: 32px;
`;

const ClassPlanHeader = () => {
  return (
    <Row>
      <Cell>
        <Grid container alignItems="center" justify="center" spacing={1}>
          <Typography variant="h5">Planejamento do conteúdo</Typography>
        </Grid>
      </Cell>
      <Cell>
        <Grid container alignItems="center" justify="center" spacing={1}>
          <Typography variant="h5">Conteúdo</Typography>
        </Grid>
      </Cell>
    </Row>
  );
};

export default ClassPlanHeader;
